import { render, staticRenderFns } from "./PackagePermissions.vue?vue&type=template&id=730fcff6"
import script from "./PackagePermissions.vue?vue&type=script&lang=js"
export * from "./PackagePermissions.vue?vue&type=script&lang=js"
import style0 from "./PackagePermissions.vue?vue&type=style&index=0&id=730fcff6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VAvatar,VDataTable,VIcon,VList,VListItem,VListItemTitle,VMenu})
